import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import useUploadQueue from './useUploadQueue';
import { buildCaseFieldUpdateCallback } from '../utils/uploadUtils';

const useFinalizeLifecareUpload = ({ caseId }) => {
    const { isLoading, queueFiles } = useUploadQueue(caseId);
    const uploadQueue = useSelector((state) => state.fileUpload?.uploadQueue ?? []);
    const activeUploads = useSelector((state) => state.fileUpload?.activeUploads ?? {});
    const isUploadPending = isLoading || uploadQueue.length > 0 || Object.keys(activeUploads).length > 0;

    const dedicatedFileUpload = useCallback(async ({ files, caseRecordType, updateCasePayload }) => {
        const callback = updateCasePayload ? buildCaseFieldUpdateCallback(updateCasePayload) : null;
        const { filesWithMetadata } = await queueFiles({
            files,
            caseRecordType,
            callback,
        });
        return filesWithMetadata;
    }, [queueFiles]);

    return {
        isLoading,
        isUploadPending,
        dedicatedFileUpload,
    };
};

export default useFinalizeLifecareUpload;
